import { render, staticRenderFns } from "./VueSelectTempFaculty1.vue?vue&type=template&id=f00129c8&scoped=true&"
import script from "./VueSelectTempFaculty1.vue?vue&type=script&lang=js&"
export * from "./VueSelectTempFaculty1.vue?vue&type=script&lang=js&"
import style0 from "./VueSelectTempFaculty1.vue?vue&type=style&index=0&id=f00129c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f00129c8",
  null
  
)

export default component.exports